import React from "react";

const HamburgerMenu = ({onClick}) => {
    return (
        <div className="hamburgermenu" onClick={onClick}>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}

export { HamburgerMenu }